import { Route, Routes } from "react-router-dom";
import { SideNav } from "./SideNav.tsx";
import { NotFound } from "./NotFound.tsx";

/**
 * サイドバーの要素
 *
 */
interface NavItem {
  path: string;
  label: string;
  children?: NavItem[];
}

/**
 * フレームのプロパティ
 * @param {NavItem[]} items - サイドバーの要素
 * @param {string[]} trustedUrls - 信頼できるURLのリスト
 * @param {Array.<{ path: string, element: JSX.Element }>} routes - ルートのリスト
 * @param {Function} onNavClick - ナビゲーションリンクがクリックされたときのハンドラ
 */
interface GenericFrameProps {
  navItems: NavItem[];
  trustedUrls: string[];
  routes: { path: string; element: JSX.Element }[];
}

/**
 * ジェネリックフレーム
 * @param {GenericFrameProps} props - プロパティ
 * @returns {JSX.Element} ジェネリックフレームの JSX element
 */
export function GenericFrame({
  navItems,
  trustedUrls,
  routes,
}: GenericFrameProps): JSX.Element {
  return (
    <>
      {/* メインコンテンツ2カラム左エリア ここから */}
      <div className="l-content-left">
        <Routes>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      {/* メインコンテンツ2カラム左エリア ここまで */}

      {/* メインコンテンツ2カラム右エリア ここから */}
      <div className="l-content-right">
        <SideNav items={navItems} trustedUrls={trustedUrls} />
      </div>
      {/* メインコンテンツ2カラム右エリア ここまで */}
    </>
  );
}
